module.exports = __webpack_public_path__ + "img/ic_hotel_taxi.c8aabd65.png";